// extracted by mini-css-extract-plugin
export var isOverflowHidden = "_8sNd";
export var root = "Qqo9";
export var rootScrollHidden = "LL20";
export var rootSearching = "ol7-";